import type { SchemaPath } from '@angular/forms/signals';
import { validate } from '@angular/forms/signals';

/**
 * Schema fragment that fails when a string field contains only whitespace.
 *
 * Trims the string and, if the resulting length is 0, reports a
 * `{ kind: 'whitespace' }` validation error. Useful for required text inputs
 * where leading/trailing spaces should not satisfy the requirement.
 *
 * @param path The schema path of the string field to validate.
 * @example
 * form(model, (p) => {
 *   required(p.name);
 *   noWhitespaceValidator(p.name);
 * });
 */
export function noWhitespaceValidator(path: SchemaPath<string>): void {
  validate(path, (ctx) => {
    const v = ctx.value();
    return typeof v === 'string' && v.trim().length === 0
      ? { kind: 'whitespace' }
      : null;
  });
}
